import { render, staticRenderFns } from "./AdminUsuaris.vue?vue&type=template&id=2c24dbdb&"
import script from "./AdminUsuaris.vue?vue&type=script&lang=js&"
export * from "./AdminUsuaris.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsuaris.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports